<template>
	<div class="strategy-page">
		<!-- 顶部返回栏 -->
		<header class="top-nav">
            <button class="back-btn" @click="goBack">
                <i class="iconfont icon-zuojiantou"></i>
                
            </button>
			<h2><span>{{ $t('Strategies') }}</span></h2>
        </header>
		<!-- 经理信息卡片 -->
		<div class="manager-card" v-if="infos != null">
			<div class="manager-info">
				<div class="avatar">
					<img :src="infos.img" alt="avatar" />
				</div>
				<div class="manager-text">
					<h2>{{infos.title}}</h2>
					<p>{{infos.guarantee}}</p>
				</div>
				<div class="duration-tag">{{infos.day_date_num_text}}</div>
			</div>

			<!-- 数据统计网格 -->
			<div class="stats-grid">
				<div class="stat-item">
					<p class="stat-label">{{$t('TodayRate')}}</p>
					<p class="stat-value">+{{ infos.interest_rate.today.today_profit_rate  }}%</p>
				</div>
				<div class="stat-item">
					<p class="stat-label">{{$t('TotalGrossProfit')}}</p>
					<p class="stat-value">+{{ infos.interest_rate.today.total_gross_profit  }}%</p>
				</div>
				<div class="stat-item">
					<p class="stat-label">{{$t('AnnualReturn')}}</p>
					<p class="stat-value">+{{ infos.interest_rate.today.current_annual_rate }}%</p>
				</div>
				<div class="stat-item">
					<p class="stat-label">{{$t('MaximumDrawdown')}}</p>
					<p class="stat-value">{{infos.maximum_drawdown}}%</p>
				</div>
				<div class="stat-item">
					<p class="stat-label">{{$t('WinRate')}}</p>
					<p class="stat-value">+{{ infos.interest_rate.today.win_rate }}%</p>
				</div>
				<div class="stat-item">
					<p class="stat-label">{{$t('PreviousProfitRate')}}</p>
					<p class="stat-value">+{{ infos.interest_rate.today.preyious_orofit_rate  }}%</p>
				</div>
			</div>
		</div>

		<!-- 当前交易卡片 -->
		<div class="trading-card" v-if="infos != null">
			<h3>{{$t('CurrentTrading')}}</h3>
			<div class="trading-stats">
				<div class="stat-item">
					<p class="stat-label">{{$t('Previous')}}</p>
					<p class="stat-value">+{{ infos.interest_rate.today.preyious_orofit_rate  }}%</p>
				</div>
				<div class="stat-item">
					<p class="stat-label">{{$t('Current')}}</p>
					<p class="stat-value">+{{ infos.interest_rate.today.current_annual_rate }}%</p>
				</div>
			</div>
		</div>

		<!-- 标签栏 -->
		<div class="tab-bar">
			<div class="tab-item" :class="{'active':tabIndex === 0}" @click="tabIndex = 0">
				<span class="iconfont icon-qushi"></span>
				<span>{{ $t('Charts') }}</span>
			</div>
			<div class="tab-item" :class="{'active' : tabIndex === 1}" @click="tabIndex = 1">
				<span class="iconfont icon-duigou"></span>
				<span>{{$t('Historical')}}</span>
			</div>
		</div>

		<!-- 图表卡片 -->
		<div class="chart-card" v-if="tabIndex === 0">
			<div class="chart-header">
				<h3>{{$t('ProfitRate')}}</h3>
				<span class="info-icon">i</span>
			</div>
			<div class="chart-container" v-if="infos != null && chartData.length > 0">
				<charts ref="chart" :arrs="chartData"/>	
			</div>
		</div>
		<div class="chart-card" v-if="tabIndex === 0">
			<div class="chart-header">
				<h3>{{$t('DailyYield')}}</h3>
				<span class="info-icon">i</span>
			</div>
			<div class="chart-container" v-if="infos != null && chartData2.length > 0">
				<charts2 ref="chart2" :arrs="chartData2"/>	
			</div>
		</div>
		<!-- 历史订单列表 -->
		<div class="order-list" v-if="tabIndex === 1 && infos != null">
			<!-- 订单项 1 -->
			<div class="order-card" v-for="(item,index) in infos.order" :key="index">
				<div class="order-header"> 
					<div class="order-title">{{item.symbol  }}</div>
					<div class="order-tag" :style="{'color':item.profit_status ==1?'#A7F3D0':'#FCA5A5'}">{{item.profit_status == 1?$t('止盈'):$t('止损')}}</div>
				</div>
				<div class="order-time">{{item.start_time }} -> {{ item.end_time }}</div>
				<div class="order-profit" :class="{'positive':item.profit_status ==1,'negative':item.profit_status ==0}">{{ item.float_price }}</div>

				<div class="order-divider"></div>

				<div class="order-prices">
					<div class="price-item">
						<div class="price-label">{{$t('打开')}}</div>
						<div class="price-value">{{item.open_price}}</div>
					</div>
					<div class="price-item">
						<div class="price-label">{{$t('关闭')}}</div>
						<div class="price-value">{{item.close_price}}</div>
					</div>
				</div>
			</div>
			<div v-if="infos.order.length == 0" class="msg" style="padding: 20px;margin: 15px;text-align: center;font-size: 14px;">
				 {{ $t('暂无订单') }}
			</div>
			<div style="height: 70px;"></div>
		</div>
		<div style="height: 170px;"></div>
	</div>
</template>

<script>
import Fetch from "../../utils/fetch";
import Vue from 'vue';
import { Progress, Dialog, Field, Toast } from 'vant';
import charts from '../../components/charts.vue'
import charts2 from '../../components/charts2.vue'
Vue.use(Progress).use(Dialog).use(Field);
export default {
	created() {
		this.$parent.footer('items', false);
	},
	name: 'StrategyPage',
	components:{
		charts,
		charts2
	},
	data() {
		return {
			tabIndex: 0,
			infos:null,
			chartData: [],
			chartData2:[]
		}
	},
	mounted() {
		this.start();
	},
	methods: {
		switchTab(index) {
			// 这里可以结合父组件实现 tab 切换逻辑
			this.tabIndex = index
		},
		goBack() {
            this.$router.go(-1)
        },
		start() {
			Fetch('/index/item_detail', {
				id: this.$router.history.current.params.code
			}).then(res => {
				this.infos = res.data;
				console.log(res.data.interest_rate,'res.data.interest_rate')
				this.chartData = []
				this.chartData2 = []
				res.data.interest_rate.profit_rate.forEach(x => {
					let obj = {
						time:x.time,
						rate:x.today_profit_rate
					}
					this.chartData.push(obj)
				})
				
				res.data.interest_rate.daily_yield.forEach(x => {
					let obj = {
						time:x.time,
						rate:x.daily_output
					}
					this.chartData2.push(obj)
				})
			})
		},
	}
}
</script>

<style scoped lang="less">
/* 顶部导航 */
.top-nav {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    padding: 15px;
    background: #07291C;
	position: sticky;
	top: 0px;
	z-index: 10;
	h2 {
		margin-left: 10px;
	}
}

.back-btn,
.rules-btn {
    border: none;
    color: #ffffff;
    padding: 8px 12px;
    border-radius: 8px;
    font-size: 18px;
    cursor: pointer;
}

.rules-btn {
    background: #0C1F33;
}
/* 全局页面样式 */
.strategy-page {
	background: #06281B;
background: linear-gradient(178deg, rgba(6, 40, 27, 1) 0%, rgba(1, 13, 11, 1) 68%, rgba(0, 9, 7, 1) 99%);
	min-height: 100dvh;
	color: #e0f2f1;
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* 经理卡片 */
.manager-card {
	background: #0F5242;
	background: linear-gradient(39deg, rgba(15, 82, 66, 1) 0%, rgba(2, 28, 23, 1) 100%);
	border-radius: 15px;
	margin: 12px;
	padding: 15px;
	border: 2px solid #072C21;
}

.manager-info {
	display: flex;
	align-items: center;
	margin-bottom: 20px;
}
.avatar {
	width: 60px;
	height: 60px;
	border-radius: 50%;
	background: #fff;
	border: 1px solid #fff;
	overflow: hidden;
	margin-right: 12px;
}
.avatar img {
	width: 60px;
	height: 60px;
	object-fit: contain;
}

.manager-text {
	width: calc(100% - 120px);
}
.manager-text h2 {
	width: 100%;
	font-size: 18px;
	margin: 0;
}

.manager-text p {
	font-size: 12px;
	color: #90B9AB;
	margin: 4px 0 0;
}

.duration-tag {
	margin-left: auto;
	background-color: #00d084;
	color: #0a1a1a;
	padding: 6px;
	border-radius: 6px;
	font-size: 12px;
	font-weight: 600;
}

/* 统计网格 */
.stats-grid {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 12px;
}

.stat-item {
	border: 1px solid #1c6d59;
	border-radius: 8px;
	padding:8px 12px;
	background: #0C5542;
}

.stat-label {
	font-size: 12px;
	color: #80cbc4;
	margin: 0 0 8px;
}

.stat-value {
	font-size: 18px;
	font-weight: 600;
	margin: 0;
	color: #ffffff;
}

.stat-value.positive {
	color: #00d084;
}

.stat-value.negative {
	color: #ef5350;
}

/* 交易卡片 */
.trading-card {
	background: #0F5242;
	background: linear-gradient(39deg, rgba(15, 82, 66, 1) 0%, rgba(2, 28, 23, 1) 100%);
	border-radius: 16px;
	margin: 12px;
	padding: 16px;
	.stat-item {
		background: rgba(4,44,34,0.8);
		border: 1px solid #0C4939;
	}
}

.trading-card h3 {
	font-size: 16px;
	margin: 0 0 16px;
}

.trading-stats {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 12px;
}

/* 标签栏 */
.tab-bar {
	display: flex;
	border-bottom: 1px solid #143f3f;
	margin: 12px 12px 0;
}

.tab-item {
	flex: 1;
	text-align: center;
	padding: 12px 0;
	font-size: 14px;
	color: #779386;
	border-bottom: 2px solid transparent;
	.iconfont {
		font-size: 14px;
		margin-right: 5px;
	}
}

.tab-item.active {
	color: #6FEAB8;
	border-bottom-color: #6FEAB8;
}

.tab-item .icon {
	margin-right: 4px;
}

/* 图表卡片 */
.chart-card {
	background: linear-gradient(39deg, rgba(15, 82, 66, 1) 0%, rgba(2, 28, 23, 1) 100%);
	border-radius: 16px;
	margin: 12px;
	padding: 16px;
}

.chart-header {
	display: flex;
	align-items: center;
	margin-bottom: 16px;
}

.chart-header h3 {
	font-size: 18px;
	margin: 0;
}

.info-icon {
	margin-left: auto;
	width: 20px;
	height: 20px;
	border-radius: 50%;
	background-color: #143f3f;
	color: #80cbc4;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 12px;
}

.chart-container {
	position: relative;
	display: flex;
	align-items: flex-end;
	justify-content: center;
}

.y-axis {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	height: 250px;
	margin-right: 8px;
	font-size: 12px;
	color: #80cbc4;
}

.chart-line {
	flex: 1;
	position: relative;
}

.chart-line svg {
	width: 100%;
	height: 250px;
}

.x-axis {
	display: flex;
	justify-content: space-between;
	margin-top: 8px;
	font-size: 12px;
	color: #80cbc4;
}

.floating-badge {
	position: absolute;
	left: -30px;
	top: 120px;
	width: 60px;
	height: 60px;
	border-radius: 50%;
	background-color: #0a1a1a;
	border: 2px solid #00d084;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #00d084;
	font-size: 14px;
	font-weight: 600;
}

/* 订单列表 */
.order-list {
	padding: 12px;
	display: flex;
	flex-direction: column;
	gap: 16px;
}

/* 订单卡片 */
.order-card {
	background: #0F5242;
	background: linear-gradient(39deg, rgba(15, 82, 66, 1) 0%, rgba(2, 28, 23, 1) 36%, rgba(8, 54, 44, 1) 76%, rgba(15, 82, 66, 1) 100%);
	border-radius: 16px;
	padding: 16px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

/* 订单头部 */
.order-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 8px;
}

.order-title {
	font-size: 14px;
	font-weight: 600;
	color: #F7F2EA;
}

.order-tag {
	background-color: #143f3f;
	color: #A7F3D0;
	padding: 4px 10px;
	border-radius:12px;
	border: 1px solid #23634E;
	font-size: 10px;
}

/* 订单时间 */
.order-time {
	font-size: 12px;
	color: #F7F2EA;
	margin-bottom: 8px;
}

/* 订单收益 */
.order-profit {
	font-size: 18px;
	font-weight: 600;
	text-align: right;
	margin-bottom: 15px;
}

.order-profit.positive {
	color: #6EE7B7;
}

.order-profit.negative {
	color: #F87171;
}

/* 分割线 */
.order-divider {
	height: 1px;
	background-color: #CFD4D8;
	margin-bottom: 15px;
}

/* 价格区域 */
.order-prices {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 16px;
}

.price-item {
	background-color: #0F362F;
	border-radius: 8px;
	padding: 12px;
	border:1px solid #4E8371;
}

.price-label {
	font-size: 12px;
	color: #fff;
	margin-bottom: 8px;
}

.price-value {
	font-size: 16px;
	font-weight: 500;
	color: #e0f2f1;
}
</style>